/// <reference types="./style_guideline.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $calendar from "../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class StyleGuideline extends $CustomType {
  constructor(id, org_id, creator, name, content, created_at, updated_at) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.creator = creator;
    this.name = name;
    this.content = content;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }
}

export class NewStyleGuideline extends $CustomType {
  constructor(id, name, content) {
    super();
    this.id = id;
    this.name = name;
    this.content = content;
  }
}

export function new_style_guideline() {
  return new NewStyleGuideline(new $option.None(), "", "");
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "org_id",
        $decode.string,
        (org_id) => {
          return $decode.field(
            "creator",
            $decode.string,
            (creator) => {
              return $decode.field(
                "name",
                $decode.string,
                (name) => {
                  return $decode.field(
                    "content",
                    $decode.string,
                    (content) => {
                      return $decode.field(
                        "created_at",
                        $decrypt.timestamp(),
                        (created_at) => {
                          return $decode.field(
                            "updated_at",
                            $decrypt.timestamp(),
                            (updated_at) => {
                              return $decode.success(
                                new StyleGuideline(
                                  id,
                                  org_id,
                                  creator,
                                  name,
                                  content,
                                  created_at,
                                  updated_at,
                                ),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode(style_guideline) {
  return $json.object(
    toList([
      ["id", $json.string(style_guideline.id)],
      ["org_id", $json.string(style_guideline.org_id)],
      ["creator", $json.string(style_guideline.creator)],
      ["name", $json.string(style_guideline.name)],
      ["content", $json.string(style_guideline.content)],
      [
        "created_at",
        $json.string(
          $timestamp.to_rfc3339(
            style_guideline.created_at,
            $calendar.utc_offset,
          ),
        ),
      ],
      [
        "updated_at",
        $json.string(
          $timestamp.to_rfc3339(
            style_guideline.updated_at,
            $calendar.utc_offset,
          ),
        ),
      ],
    ]),
  );
}
